/**
 * The calendar module (`@wiztime/core/calendar`) pulls in the lunar library (about 70 KB
 * compressed). It is imported only through this dynamic `import()` so the bundler emits it as a
 * separate chunk that the first screen never loads; a static import anywhere in first-screen
 * code would pull it back in. Types may be imported statically (`import type`), they are erased.
 */
export type CalendarApi = typeof import('@wiztime/core/calendar');

let pending: Promise<CalendarApi> | null = null;

/** Load the module once; a failed load is forgotten so that the next call tries again. */
export function loadCalendar(): Promise<CalendarApi> {
  pending ??= import('@wiztime/core/calendar').catch((error: unknown) => {
    pending = null;
    throw error;
  });
  return pending;
}
